import React, { useEffect, useState, useRef } from "react";
import { withRouter, Prompt } from "react-router";
import classnames from "classnames";
import { connect } from "react-redux";

import * as actions from "../../../../store/actions";
import constants, { getOnboardingPath } from "../../../../constants";
import Row from "../../../../components/uiElements/grid/Row";
import Card from "../../../../layout/Onboarding/Card";
import Col from "../../../../components/uiElements/grid/Col";
import { toast } from "react-toastify";
import DoctorSignatureInput from "../../../../components/formElements/file/doctorSignature";
import Button from "../../../../components/formElements/button/Button";
import OnboardingIcon from "../../../../components/uiElements/icons/onboardingIcons/OnboardingIcon";
import {
  VALIDATE_SIGNATURE,
  REMOVE_VALIDATIONS,
} from "../../../../store/actions/actionTypes";

const Signature = ({
  setPersonalInfo,
  personalInfo,
  deleteFileFromS3,
  updateDoctorSignature,
  redirectedPath,
  history,
  validateData,
  form,
}) => {
  const onFileError = error => {
    toast.error(error, {
      position: constants.TOAST_POSITION,
    });
  };
  const myRef = useRef();

  useEffect(() => {
    if (form && form.signatureValid) {
      if (
        redirectedPath ||
        (personalInfo.docsignature && personalInfo.dataChanged)
      ) {
        updateDoctorSignature(
          "update",
          () =>
            personalInfo.dataLoaded &&
            personalInfo.dataChanged &&
            history.push(getOnboardingPath("/step4"))
        );
      } else {
        updateDoctorSignature("save", () => {
          history.push(getOnboardingPath("/step4"));
        });
      }
    } else if (form.signatureValid === false) {
      myRef?.current?.querySelector(":invalid")?.scrollIntoView({
        behavior: "smooth",
      });
    }
    form.signatureValid = false;
    toast.error(form.signatureImage, {
      position: constants.TOAST_POSITION,
    });
    form.personalInfo = false;
    // eslint-disable-next-line
  }, [form]);

  return (
    <>
      {redirectedPath && (
        <Prompt
          when={personalInfo.dataChanged}
          message="You have unsaved changes, are you sure you want to leave?"
        />
      )}
      <div
        className={classnames(
          "onboarding-container"
          // personalInfo.dataLoaded && !redirectedPath && "disable"
        )}
      >
        <p className="onboarding-header m-0 pb-3">Signature</p>
        <Row>
          <Card title="Upload Signature">
            <Row className="mb-5 mt-n3">
              <Col size={["md-12"]}>
                <DoctorSignatureInput
                  showPreview
                  buttonClass="w-100"
                  name="docsignature"
                  files={personalInfo.docsignature}
                  onChange={files => setPersonalInfo(files)}
                  onError={error => onFileError(error)}
                  onRemove={file => deleteFileFromS3(file)}
                  title="Upload Signature"
                />
              </Col>
            </Row>
          </Card>

          {!redirectedPath ? (
            <Button
              type="secondary"
              indicatorButton
              className={classnames(
                "float-right next-button",
                personalInfo.dataLoaded && "enable"
              )}
              label={<OnboardingIcon type="nextButton" />}
              onClick={() =>
                personalInfo.dataLoaded &&
                !personalInfo.dataChanged &&
                personalInfo.docsignature
                  ? history.push(getOnboardingPath("/step4"))
                  : validateData(personalInfo)
              }
            />
          ) : (
            <Button
              type="info"
              disabled={!personalInfo.dataChanged && true}
              className={classnames("w-75 mx-auto mb-4")}
              onClick={() => validateData(personalInfo)}
              label="Save Changes"
            />
          )}
        </Row>
      </div>
    </>
  );
};

const mapStoreToProps = ({ onboarding, auth, validation }) => ({
  personalInfo: onboarding.personalInfo,
  redirectedPath: auth.redirectToOnboardingPath,
  form: validation.data,
});

const mapDispatchToProps = dispatch => ({
  setPersonalInfo: updatedData =>
    dispatch(actions.setPersonalInfo(updatedData)),
  updateDoctorSignature: (action, cb) =>
    dispatch(actions.updateDoctorSignature(action, cb)),
  deleteFileFromS3: (file, cb) => dispatch(actions.deleteFileFromS3(file, cb)),
  validateData: sign =>
    dispatch(actions.validateData(VALIDATE_SIGNATURE, sign)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(Signature)
);
